<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="row mb-3">
                    <div class="col-xl-3 col-lg-3 col-sm-4 mt-2">
                        <p class="mb-1 text-nowrap">{{$t('table.filter_by_discipline')}}</p>
                        <multiselect v-model="selectedDisciplineFilter"
                            :options="currentDisciplines"
                            :multiple="false"
                            :hide-selected="false"
                            placeholder=""
                            label="name" track-by="id"
                            :selectLabel="''"
                            @input="updateDisciplineFilter"
                        >
                            <template slot="clear" slot-scope="props">
                                <div 
                                    v-if="selectedDisciplineFilter != null" 
                                    class="multiselect__clear" 
                                    @mousedown.prevent.stop="clearSelectedDisciplineFilter"
                                >
                                </div>
                            </template>
                            <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                            <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                        </multiselect>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-sm-4 mt-2 mt-2" v-if="filters.discipline_id != ''">
                        <p class="mb-1 text-nowrap">{{$t('table.filter_by_drawing')}}</p>
                        <multiselect v-model="selectedDrawingFilter"
                            :options="currentDrawingsFilter"
                            :multiple="false"
                            :clear-on-select="true"
                            :hide-selected="false"
                            :loading="isDrawingLoadingFilter"
                            :preserve-search="true"
                            placeholder=""
                            label="info" track-by="id"
                            :selectLabel="''"
                            @search-change="onDrawingFilter"
                            @input="onFilterByDrawing"
                        >
                            <template slot="clear" slot-scope="props">
                                <div 
                                    v-if="selectedDrawingFilter != null" 
                                    class="multiselect__clear" 
                                    @mousedown.prevent.stop="clearSelectedDrawingFilter"
                                >
                                </div>
                            </template>
                            <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                            <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                        </multiselect>
                    </div>
                </div>

                <data-table
                    v-if="tableLoaded"
                    :exportable="this.$store.getters.hasPermission(['project_painting'], ['read'])" title=""
                    :rows="getData.rowData"
                    :columns="columnData"
                    :perPage="perPage"
                    :rowsCount="rowsCount"
                    :currentPage="currentPage"
                    :pageCount="pageCount"
                    :rowChangeSelectOptions="rowChangeSelectOptions"
                    :disabledInputs="!this.$store.getters.hasPermission(['project_painting'], ['update'])"
                    @changePage="changePage"
                    @searchEvent="searchEvent"
                    @orderByEvent="orderByEvent"
                    @rowClickDelete="onDeleteRow"
                    @rowChangeTextInput="onEditRow"
                    @rowChangeSelect="onEditRow"
                    @rowChangeTextAreaInput="onEditRow"
                    @rowChangeBooleanInput="onEditRow"
                    @rowChangeBCheckBox="onChangeBCheckBoxRow"
                    @rowClickCheck="onClickCheck"
                    @rowClickAddFiles="onAddFiles"
                    @exportButtonClick="onExportButton"
                >
                </data-table>

                <b-btn 
                    v-if="this.$store.getters.hasPermission(['project_painting'], ['create']) && archived == 0"
                    class="btn btn-default mt-3 mr-2" 
                    @click="onAddRow"
                >
                    <i class="fa fa-plus-circle mr-1"></i> {{$t('general.construction.painting.create_button')}}
                </b-btn>

                <b-btn 
                    v-if="this.$store.getters.hasPermission(['project_painting'], ['create']) && archived == 0"
                    class="btn btn-dark mt-3 mr-2" 
                    @click="onPDF"
                >
                    <i class="fa fa-file-pdf-o"></i> {{$t('table.create_pdf')}}
                </b-btn>
            </div>
        </div>

        <b-modal 
			ref="saveModal" 
			id="saveModal" 
			:title="actionTitle"
            :ok-title="$t('misc.ok')" 
			:cancel-title="$t('misc.cancel')"
			size="md"
			@ok="saveAction"
			@hidden="clearSearches"
		>
			<div class="row">
				<div class="col-lg-12">
					<div class="row mb-3">
						<div class="col-lg-3">
							<label>{{ $t('table.discipline') }}</label>
						</div>
						<div class="col-lg-9">
							<multiselect v-model="selectedDiscipline"
								:options="currentDisciplines"
								:multiple="false"
								:hide-selected="false"
								placeholder=""
								label="name" track-by="id"
								:selectLabel="''"
								@input="updateDiscipline"
							>
								<template slot="clear" slot-scope="props">
									<div 
										v-if="selectedDiscipline != null" 
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedDiscipline"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
						    </multiselect>
						</div>
					</div>
				</div>

				<div class="col-lg-12" v-if="model.discipline_id != null">
					<div class="row mb-3">
						<div class="col-lg-3">
							<label>{{ $t('table.drawing') }}</label>
						</div>
						<div class="col-lg-9">
							<multiselect v-model="selectedDrawing"
								:options="currentDrawings"
								:multiple="false"
								:clear-on-select="true"
								:hide-selected="false"
								:loading="isDrawingLoading"
								:preserve-search="true"
								placeholder=""
								label="info" track-by="id"
								:selectLabel="''"
								@search-change="onDrawingSearch"
								@input="updateDrawing"
							>
								<template slot="clear" slot-scope="props">
									<div 
										v-if="selectedDrawing != null" 
										class="multiselect__clear" 
										@mousedown.prevent.stop="clearSelectedDrawing"
									>
									</div>
								</template>
								<span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
								<span slot="noResult">{{ $t('modal.general.no_results') }}</span>
						    </multiselect>
						</div>
					</div>
				</div>

				<div class="col-lg-12" v-if="model.discipline_id == 1 && model.drawing_id != null">
					<div class="row mb-3">
						<div class="col-lg-3">
							<label>{{ $t('table.spools') }}</label>
						</div>
						<div class="col-lg-9">
							<multiselect v-model="selectedSpools"
                                :options="currentSpools"
                                :multiple="true"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isSpoolsLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="spool_no" track-by="id"
                                :selectLabel="''"
                                @search-change="onSpoolsSearch"
                                @input="updateSpools"
                            >
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
						</div>
					</div>
				</div>
			</div>
		</b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>

        <add-files-modal
            ref="addFilesModal"
            :fileType="'painting'"
            :filterBy="'painting_id'"
            :canUploadFiles="(archived != 1)"
        >
        </add-files-modal>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';

import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';
import AddFilesModal from '@/components/global/modals/AddFilesModal.vue';

export default {
    name: 'painting_table',
    components: {
        DataTable,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
        AddFilesModal,
    },
    props: {
        archived: {
            type: Number,
            required: true,
        },
        columnData: {
            type: Array,
            required: true,
        },
        currentDisciplines: {
            type: Array,
            required: true,
        },
        rowChangeSelectOptions: {
            type: Object,
            default () {
                return null;
            },
        },
    },
    data() {
        return {
            tableName: 'painting',
            tableNameTranslated: Vue.i18n.translate('general.construction.painting.title_modal'),
            tableLoaded: false,
            row: null,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',

            selectedDisciplineFilter: null,

            selectedDrawingFilter: null,
            currentDrawingsFilter: [],
            isDrawingLoadingFilter: false,

            selectedDiscipline: null,

            selectedDrawing: null,
            currentDrawings: [],
            isDrawingLoading: false,
            
            selectedSpools: null,
            currentSpools: [],
            isSpoolsLoading: false,
            
            pdfValues: {},

            filters: {
                discipline_id: '',
                drawing_id: '',
            },

            model: {
                discipline_id: null,
                drawing_id: null,
            },
            
            getData: {
                rowData: [],
            },
        }
    },
    mounted () {
        this.onLoadTable();
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        infoMsg(msg) {
            miniToastr.info(msg, Vue.i18n.translate('messages.info'), 4000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable()
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            let data = http.route(this.tableName + '?project_id=' + this.$route.params.id + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType + '&filters[closed]=' + this.archived + '&filters[discipline_id]=' + this.filters.discipline_id + '&filters[drawing_id]=' + this.filters.drawing_id).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;

                    let tmp_data = response.data;
                    tmp_data.forEach(field => {
                        //PDF checkboxes
                        field.create_pdf = false;
                        Object.keys(this.pdfValues).forEach((key) => {
                            if (key == field.id && this.pdfValues[key]) {
                                field.create_pdf = this.pdfValues[key];
                            }
                        });

                        if (this.archived == 0) {
                            field.insulation = Boolean(field.insulation);
                        } else {
                            field.insulation = (field.insulation == 1) ? Vue.i18n.translate('misc.yes') : Vue.i18n.translate('misc.no') ;
                        }

                        if (field.drawing.line == null) {
                            field.drawing.line = { 
                                'area': '',
                                'line_number': '',
                                'line_class': '',
                                'line_size': '',
                                'pipe_material': '',
                            };
                        }

                        if (field.work_type == null) {
                            field.work_type = { 
                                'value': '',
                            };
                        }

                        if (field.painting_system == null) {
                            field.painting_system = { 
                                'value': '',
                            };
                        }

                        if (field.ral == null) {
                            field.ral = { 
                                'value': '',
                            };
                        }
                    });
                    this.getData.rowData = tmp_data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        clearSearches () {
			this.clearSelectedDiscipline();
			this.currentDrawings = [];
			this.currentSpools = [];
            this.selectedSpools = [];
		},
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.clearSearches();
            this.$refs.saveModal.show();
        },
        onChangeBCheckBoxRow (value, row, index, column, column_name) {
            this.pdfValues[row.id] = value;
        },
        onPDF () {
            let put_data = {
                project_id: this.$route.params.id,
                paintings: this.pdfValues,
            };

            Object.keys(put_data.paintings).forEach((key) => {
                if (!put_data.paintings[key]) {
                    delete put_data.paintings[key];
                }
            });

            let data = http.route('painting_pdf').post(put_data, true);
            data.then(response => {
                if(response.isError == false) {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            }); 
        },
        onEditRow (row, index, column, column_name, value) {
            let put_data = {};

            put_data['project_id'] = this.$route.params.id;
            put_data[column_name] = value;

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            http.route(this.tableName + '/' + row.id).patch(put_data, true)
            .then(response => {
                if (!response.isError) {
                    row[column.toString()] = !row[column.toString()];
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onClickCheck (row, index, column) {
            if (column != 'in_pdf') {
                let put_data = {};

                put_data['project_id'] = this.$route.params.id;
                put_data[column] = !row[column.toString()];

                Object.keys(put_data).forEach(key => {
                    if (put_data[key] === '') {
                        put_data[key] = null;
                    }
                });

                http.route(this.tableName + '/' + row.id).patch(put_data, true)
                .then(response => {
                    if (!response.isError) {
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        this.onLoadTable();
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            }
        },
        saveAction (e) {
            e.preventDefault();

            if (this.model.discipline_id == null) {
                this.errorMsg(Vue.i18n.translate('errors.discipline.required'));
                return 0;
            }

            let put_data = {
                project_id: this.$route.params.id,
                drawing_id: this.model.drawing_id,
                spools: [],
            };

            if (this.model.discipline_id == 1 && this.model.drawing_id != null && this.selectedSpools.length > 0) {
                this.selectedSpools.forEach((spool, index) => {
                    put_data.spools[index] = spool.id;
                });
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            let data = http.route(this.tableName).post(put_data, true);
            data.then(response => {
                if(response.isError == false) {
                    this.onLoadTable();
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                    this.$refs.saveModal.hide();
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (response.isError == false) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }

            this.$refs.deleteModal.hide();
        },
        onAddFiles (row) {
            this.$refs.addFilesModal.showModal(row);
        },
        onExportButton () {
            http.route(this.tableName + '?project_id=' + this.$route.params.id + '&filters[closed]=' + this.archived + '&filters[discipline_id]=' + this.filters.discipline_id + '&filters[drawing_id]=' + this.filters.drawing_id).exportExcel({
                export: 1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'painting.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        //Filters
        onFilterByDiscipline (discipline) {
            this.filters.discipline_id = (discipline != null) ? discipline.id : '';

            this.onLoadTable();
            this.infoMsg(Vue.i18n.translate('messages.table_filtered'));
        },
        updateDisciplineFilter (discipline) {
			this.filters.discipline_id = (discipline != null) ? discipline.id : null;
            this.currentDrawingsFilter = [];
            this.clearSelectedDrawingFilter();
		},
		clearSelectedDisciplineFilter () {
			this.selectedDisciplineFilter = null;
			this.filters.discipline_id = '';
            this.clearSelectedDrawingFilter();
		},
        onDrawingFilter(search) {
            if (search == '') {
                this.currentDrawingsFilter = [];
                
                return false;
            }

            this.isDrawingLoadingFilter = true;
            this.filterDrawing(search, this);
        },
        filterDrawing: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id='+vm.$route.params.id+'&search_select=' + search + '&filters[parent_drawing_id]=null&filters[discipline_id]=' + vm.filters.discipline_id + '&get_all=1').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDrawingsFilter = response.data;
                }
                vm.isDrawingLoadingFilter = false;
            });
        }, 500),
        onFilterByDrawing (drawing) {
            this.filters.drawing_id = (drawing != null) ? drawing.id : '';

            this.onLoadTable();
            this.infoMsg(Vue.i18n.translate('messages.table_filtered'));
        },
        clearSelectedDrawingFilter () {
            this.selectedDrawingFilter = null;
            this.filters.drawing_id = '';
            this.onLoadTable();
            this.infoMsg(Vue.i18n.translate('messages.table_filtered'));
        },
        //Selects
        updateDiscipline (discipline) {
			this.model.discipline_id = (discipline != null) ? discipline.id : null;
            this.currentDrawings = [];
            this.clearSelectedDrawing();
		},
		clearSelectedDiscipline () {
			this.selectedDiscipline = null;
			this.model.discipline_id = null;
            this.clearSelectedDrawing();
		},
        onDrawingSearch(search) {
            if (search == '') {
                this.currentDrawings = [];
                
                return false;
            }

            if (this.model.discipline_id != null) {
                this.isDrawingLoading = true;
                this.searchDrawings(search, this);
            }
        },
        searchDrawings: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id=' + vm.$route.params.id + '&search_select=' + search + '&filters[parent_drawing_id]=null&filters[discipline_id]=' + vm.model.discipline_id + '&get_all=1').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDrawings = response.data;
                }
                vm.isDrawingLoading = false;
            });
        }, 500),
		updateDrawing (drawing) {
			this.model.drawing_id = (drawing != null) ? drawing.id : null;
            this.clearSelectedSpools();
		},
		clearSelectedDrawing () {
			this.selectedDrawing = null;
			this.model.drawing_id = null;
            this.clearSelectedSpools();
		},
        onSpoolsSearch(search) {
            if (search == '') {
                this.currentSpools = [];
                
                return false;
            }

            if (this.model.discipline_id == 1 && this.model.drawing_id != null) {
                this.isSpoolsLoading = true;
                this.searchSpools(search, this);
            }
        },
        searchSpools: _.debounce((search, vm) => {
            let data = http.route('spool?project_id=' + vm.$route.params.id + '&search_select=' + search + '&filters[drawing_id]=' + vm.model.drawing_id + '&get_all=1').get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentSpools = response.data;
                }
                vm.isSpoolsLoading = false;
            });
        }, 500),
		updateSpools (spool) {
		},
		clearSelectedSpools () {
			this.selectedSpools = [];
		},
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/project/construction/painting/painting_table.vue